/* 🤖 this file was generated by svg-to-ts */
export const matIconGetApp: {
  name: 'get-app';
  data: string;
} = {
  name: 'get-app',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 5v6h1.17L12 13.17 9.83 11H11V5h2m2-2H9v6H5l7 7 7-7h-4V3zm4 15H5v2h14v-2z"/></svg>`
};
